import type { Team } from '@sine/sine-team-switcher';

import activityEventManagerService from '../activity/activity-event-manager.service';
import authService, { authHelpers } from '../authentication/auth.service';
import { queryClient } from '../query.client';
import rxEventHub, { RxEvent } from '../services/events/rx';
import socketEventHub from '../services/events/sockets';
import siteService from '../services/site/site.service';
import siteDetailsService from '../site/siteDetails.service';
import teamScopingService from './teamScoping.service';

export default async function currentTeamListener(nextTeam: Team | undefined) {
  if (
    !nextTeam ||
    authService.getAuthState().authState === 'loading' ||
    teamScopingService.activeTeam?.id === nextTeam.id
  ) {
    return;
  }

  // We need to remove the queries before calling `authServiceInstance.refetchPermissions();`
  // If we remove them after, then any queries that get rendered prior to `authServiceInstance.refetchPermissions()` resolving will be removed
  // When a query is removed it doesn't get re-added until it is re-triggered
  queryClient.removeQueries();

  teamScopingService.setActiveTeam(nextTeam);
  await authHelpers.refetchPermissions();
  await teamScopingService.initializePendoWithMetadata();
  siteService.reset();
  siteDetailsService.reset();
  activityEventManagerService.reset();
  rxEventHub.broadcast(RxEvent.TEAM_CHANGED, {});
  socketEventHub.stop();
  await socketEventHub.start();
}
